import React from 'react';
import { Table, Breadcrumb, Tabs, Button, Divider, Popconfirm, message } from 'antd';
import { api, onGet, onDelete, onPut } from '../../../../core/api';
import OKExContractQuantEditModal from './OKExContractQuantEditModal';
import moment from 'moment';
import { getTime } from '../../../../utils/commonUtils';

const { Column } = Table;

class OKExPage extends React.Component {

    constructor() {
        super();
        this.state = {
            type: 1,
            quants: [],
            modalVisible: false
        }
        this.loadData = this.loadData.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onTabClick = this.onTabClick.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.onModalFinish = this.onModalFinish.bind(this);
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        onGet(api.getOKEx.url, api.getOKEx.params(this.state.type)).then(response => {
            if (response === undefined) {
                return;
            }
            let modelStr = ['补仓量化', '趋势量化'];
            let statusStr = ['未量化', '量化中', '已完成'];
            response.forEach(quant => {
                quant.key = quant.id;
                quant.symbolStr = quant.symbol + '永续合约（$' + quant.price + "）";
                quant.modelStr = modelStr[quant.model - 1];
                let profitLoss = 0;
                JSON.parse(quant.result).forEach(q => {
                    profitLoss += q.profitLoss;
                });
                quant.profitLoss = profitLoss.toFixed(4) + quant.symbol;
                quant.beginTime = moment(quant.back_test_begin_time).format('YYYY-MM-DD HH:mm:ss');
                quant.endTime = moment(quant.back_test_end_time).format('YYYY-MM-DD HH:mm:ss');
                quant.duration = quant.status === 2 ?
                    getTime(parseInt((quant.finish_time - quant.create_time) / 1000)) :
                    getTime(parseInt((Date.parse(new Date()) - quant.create_time) / 1000));
                quant.statusStr = statusStr[quant.status];
            });
            this.setState({ quants: response });
        });
    }

    onClick(type, item) {
        switch (type) {
            case 'add':
                this.setState({ modalVisible: true });
                break;
            case 'detail':
                this.props.history.push('/coin/okex/detail?id=' + item.key);
                break;
            case 'delete':
                onDelete(api.deleteOKExContractQuant.url(item.key)).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    message.success('删除成功');
                    this.loadData();
                });
                break;
            case 'stop':
                onPut(api.updateOKExContractQuant.url(item.key), api.updateOKExContractQuant.params('2')).then(response => {
                    if (response === undefined) {
                        return;
                    }
                    message.success('停止量化成功');
                    this.loadData();
                });
                break;
            default:
                break;
        }
    }

    onTabClick(key) {
        this.setState({ type: parseInt(key, 10) }, () => {
            this.loadData();
        });
    }

    onModalClose() {
        this.setState({ modalVisible: false });
    }

    onModalFinish() {
        this.setState({ modalVisible: false }, () => {
            this.loadData();
        });
    }

    render() {

        return (
            <div>
                <Breadcrumb className="breadcrumb">
                    <Breadcrumb.Item><a href="#/index">首页</a></Breadcrumb.Item>
                    <Breadcrumb.Item>OKEx</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ background: '#fff', paddingLeft: 20, paddingRight: 20, paddingBottom: 20 }}>
                    <Tabs activeKey={this.state.type + ''} onTabClick={this.onTabClick}>
                        <Tabs.TabPane tab="回测" key="1"></Tabs.TabPane>
                        <Tabs.TabPane tab="实盘" key="2"></Tabs.TabPane>
                    </Tabs>
                </div>
                <div className="content">
                    <Button type="primary" style={{ marginBottom: 20 }} onClick={() => this.onClick('add')}>添加</Button>
                    <div hidden={this.state.type !== 1}>
                        <Table dataSource={this.state.quants} pagination={false}>
                            <Column title="合约种类" dataIndex="symbolStr" align="center" />
                            <Column title="量化模型" dataIndex="modelStr" align="center" />
                            <Column title="总盈亏" dataIndex="profitLoss" align="center" />
                            <Column title="回测开始时间" dataIndex="beginTime" align="center" />
                            <Column title="回测结束时间" dataIndex="endTime" align="center" />
                            <Column title="量化时长" dataIndex="duration" align="center" />
                            <Column title="量化状态" dataIndex="statusStr" align="center" />
                            <Column title="操作" align="center" render={item => (
                                <span>
                                    <a onClick={() => this.onClick('detail', item)} >详情</a>
                                    {item.status == 2 &&
                                        <span>
                                            <Divider type="vertical" />
                                            <Popconfirm title="确定要删除这条记录？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('delete', item)}>
                                                <a>删除</a>
                                            </Popconfirm>
                                        </span>
                                    }
                                </span>
                            )} />
                        </Table>
                    </div>
                    <div hidden={this.state.type !== 2}>
                        <Table dataSource={this.state.quants} pagination={false}>
                            <Column title="合约种类" dataIndex="symbolStr" align="center" />
                            <Column title="量化模型" dataIndex="modelStr" align="center" />
                            <Column title="总盈亏" dataIndex="profitLoss" align="center" />
                            <Column title="量化时长" dataIndex="duration" align="center" />
                            <Column title="量化状态" dataIndex="statusStr" align="center" />
                            <Column title="操作" align="center" render={item => (
                                <span>
                                    <a onClick={() => this.onClick('detail', item)} >详情</a>
                                    {item.status == 1 &&
                                        <span>
                                            <Divider type="vertical" />
                                            <Popconfirm title="确定要停止量化？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('stop', item)}>
                                                <a>停止量化</a>
                                            </Popconfirm>
                                        </span>
                                    }
                                    {item.status == 2 &&
                                        <span>
                                            <Divider type="vertical" />
                                            <Popconfirm title="确定要删除这条记录？" okText="确定" cancelText="取消" onConfirm={() => this.onClick('delete', item)}>
                                                <a>删除</a>
                                            </Popconfirm>
                                        </span>
                                    }
                                </span>
                            )} />
                        </Table>
                    </div>
                </div>
                {this.state.modalVisible &&
                    <OKExContractQuantEditModal onModalCancel={this.onModalClose} onModalFinish={this.onModalFinish} />
                }
            </div>
        );
    }

}

export default OKExPage;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/okex/OKExPage.jsx